import { createRequestInstance } from 'services'
import { PageResponse } from 'types/Page'

const CONTENT_URL = import.meta.env.VITE_CONTENT_URL || ''

const request = createRequestInstance({
  baseURL: CONTENT_URL,
})

export async function fetchDynamicPage<T>(path: string) {
  const response = await request.get<PageResponse>('', {
    params: { full_path: path.replace('tools', 'atk-page') },
  })

  return response.data.tiles[0]
}

export async function fetchPage<T>(path: string) {
  const response = await request.get<PageResponse>('', {
    params: { full_path: path },
  })

  return response.data.tiles[0].acf
}
